import { render, staticRenderFns } from "./newsPart.vue?vue&type=template&id=1c04eea0&scoped=true"
import script from "./newsPart.vue?vue&type=script&lang=js"
export * from "./newsPart.vue?vue&type=script&lang=js"
import style0 from "./newsPart.vue?vue&type=style&index=0&id=1c04eea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c04eea0",
  null
  
)

export default component.exports